import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, ViewChild, inject } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'app-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss'],
  standalone: false
})
export class TabGroupComponent implements AfterViewInit {
  private readonly cdRef = inject(ChangeDetectorRef);


  public selectedTab: string;
  public selectedCreatable: boolean;
  public selectedRefreshable: boolean;

  @Output()
  public tabChange = new EventEmitter<string>();

  private tabsOpened: Map<string, boolean>;

  @ViewChild('content', { static: false })
  private readonly contentRef: ElementRef<HTMLDivElement>;

  public get tabs(): string[] {
    return this.children.map(child => child.attributes['label'].nodeValue);
  }

  public get selectedContent(): HTMLElement {
    return this.children.find(child => child.attributes['label'].nodeValue === this.selectedTab);
  }

  private get children(): HTMLElement[] {
    const elements: HTMLElement[] = [];
    if (!!this.contentRef) {
      const tabElements: HTMLCollectionOf<Element> = this.contentRef.nativeElement.getElementsByTagName('app-tab');
      for (let i = 0; i < tabElements.length; i++) {
        const element = tabElements.item(i);
        if (element) {
          elements.push(element as HTMLElement);
        }
      }
    }
    return elements;
  }

  public ngAfterViewInit() {
    this.tabsOpened = new Map<string, boolean>();
    this.tabs.forEach(tab => this.tabsOpened.set(tab, false));
    this.selectTab(this.tabs[0]);
    this.cdRef.detectChanges();
  }

  public selectTab(tab: string): void {
    this.children.forEach(child => child.hidden = true);
    this.selectedTab = tab;
    const selected = this.selectedContent;
    if (selected) {
      selected.hidden = false;
      this.selectedCreatable = !!selected.attributes.getNamedItem('creatable');
      this.selectedRefreshable = !!selected.attributes.getNamedItem('refreshable');
    }
    this.tabEvent('opened');
    if (!this.tabsOpened.get(this.selectedTab)) {
      this.tabEvent('loadData');
      this.tabsOpened.set(this.selectedTab, true);
    }
    this.tabChange.emit(tab);
  }

  public add() {
    this.tabEvent('create');
  }

  public refresh() {
    this.tabEvent('loadData');
  }

  private tabEvent(name: keyof TabComponent): void {
    this.selectedContent.dispatchEvent(new Event(name));
  }
}
